// React Imports
import React from 'react';
import ReactPlayer from 'react-player';
import { GENERAL } from '../../../assets/images/images';
import Helper from '../../../core/helper/helper';

class MediaSample extends React.Component {
  touchStartX = null;
  touchStartY = null;

  handleTouchStart = (e) => {
    if (e.touches && e.touches.length === 1) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    }
  };

  handleTouchEnd = (e) => {
    if (this.touchStartX === null || this.touchStartY === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const dx = touchEndX - this.touchStartX;
    const dy = touchEndY - this.touchStartY;
    // Only trigger if horizontal swipe is dominant
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 20) {
      if (dx < 0) {
        this.onClickNext(); // swipe left
      } else {
        this.onClickPrev(); // swipe right
      }
    }
    this.touchStartX = null;
    this.touchStartY = null;
  };
  constructor(props) {
    super(props);
    const { title, text, src, item: { type }, data, items, index, hasDeleteIcon } = this.props;
    this.state = {
      title: title,
      text: text,
      src: src,
      isVideo: Helper.isVideo(type),
      selectedIndex: index,
      nbrOfItems: data ? data.length : 0,
      nextArrow: index + 1 < items.length,
      prevArrow: index > 0,
      playVideo: false,
      hasDeleteIcon: hasDeleteIcon
    };
  }

  componentDidMount() {
    console.clear();
    // Capture swipe gestures anywhere on screen
    try {
      window.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      window.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    } catch (e) {
      // Fallback for environments not supporting options
      window.addEventListener('touchstart', this.handleTouchStart);
      window.addEventListener('touchend', this.handleTouchEnd);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchend', this.handleTouchEnd);
  }

  // isReady = () => {
  // }
  // onError = (error) => {
  // }
  // onBufferEnd = () => {
  // }

  onPlayClicked = () => {
    this.setState({ playVideo: !this.state.playVideo}); 
  }

  renderMedia = () => {
    const { isVideo, src, playVideo } = this.state;
    
    if (isVideo) {
      // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      return (
          <ReactPlayer
            onClick={() => this.onPlayClicked()}
            onTouchStart = {() => this.onPlayClicked()}
            controls={true}
            url={src}
            width='100%'
            height='95vh'
            playing={playVideo}
            // onReady={this.isReady}
            // onError={(e) => this.onError(e)}
            // onBufferEnd={this.onBufferEnd}
            // config={{
            //   file: {
            //     // forceHLS: isSafari,
            //     forceVideo: true, 
            //     // hlsVersion: '1.11.0',
            //   }
            // }}
            />
      );
    } else {
      return <img onClick={() => this.onPlayClicked()} className="modal-media-photo-container" src={src} alt="" />
    }
  };

  onClickNext = () => {
    const { selectedIndex } = this.state;
    const { items } = this.props;
    
    if (selectedIndex + 1 < items.length) {
      const newIndex = selectedIndex + 1;
      const nextItem = items[newIndex];
      const url = Helper.urlFullWorkImage(nextItem.url);
      this.setState({
        src: url, isVideo: Helper.isVideo(nextItem.type),
        selectedIndex: newIndex,
        nextArrow: newIndex + 1 < items.length,
        prevArrow: newIndex > 0
      });
    }
  }

  onClickPrev = () => {
    const { selectedIndex } = this.state;
    const { items } = this.props;

    if (selectedIndex > 0) {
      const newIndex = selectedIndex - 1;
      const prevItem = items[newIndex];
      const url = Helper.urlFullWorkImage(prevItem.url);
      this.setState({
        src: url, isVideo: Helper.isVideo(prevItem.type),
        selectedIndex: newIndex,
        nextArrow: newIndex + 1 < items.length,
        prevArrow: newIndex > 0
      });
    }
  }

  deleteItem = () => {
    const { selectedIndex } = this.state;
    const { items } = this.props;
    const mediaId = items[selectedIndex]?.id;
    this.props.onDeleteMediaFile(mediaId);
  }

  renderRemoveIcon = () => {
    const { hasDeleteIcon } = this.state;
    if (!hasDeleteIcon) {
      return;
    }

    return (
      <div onClick={this.deleteItem} className="icon-media-container">
        <img src={GENERAL.delete} className="icon-media-remove" alt="" />
      </div>
    );
  }

  render() {
    const { nextArrow, prevArrow, playVideo } = this.state;

    return (
      <React.Fragment>
      {this.renderRemoveIcon()}
      <div className="modal-area-container">
        <div className='arrow-section'>
          <i className={ prevArrow ? 'chevron left huge icon' : ''}
            onClick={() => this.onClickPrev()}></i>
          <i className={ nextArrow ? 'chevron right huge icon' : ''}
            onClick={() => this.onClickNext()}></i>
        </div>
        { this.renderMedia(playVideo) }
      </div>
      </React.Fragment>
    );
  }
}

export default MediaSample;
